import React from 'react'

const IconACSizes = ({ width = '28px', height = '28px', color = '#0E4C40' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill={color}
      d="M23.898 14.665h-2.74q-.562.002-1.078.144a4.1 4.1 0 0 0-3.658-2.248h-4.844c-1.595 0-2.98.915-3.658 2.248a4 4 0 0 0-1.078-.144h-2.74A4.106 4.106 0 0 0 0 18.766v4.382a2.464 2.464 0 0 0 2.46 2.46h23.08a2.464 2.464 0 0 0 2.46-2.46v-4.382a4.106 4.106 0 0 0-4.102-4.101M7.476 16.662v7.306H2.461a.82.82 0 0 1-.82-.82v-4.382a2.464 2.464 0 0 1 2.46-2.46h2.741q.335.001.644.085-.01.135-.01.271m11.407 7.306H9.117v-7.306a2.464 2.464 0 0 1 2.46-2.46h4.845a2.464 2.464 0 0 1 2.461 2.46zm7.476-.82c0 .452-.368.82-.82.82h-5.015v-7.306q0-.137-.01-.27.308-.086.644-.087h2.74a2.464 2.464 0 0 1 2.461 2.461z"
    ></path>
    <path
      fill={color}
      d="M5.472 6.918a3.65 3.65 0 0 0-3.645 3.645 3.65 3.65 0 0 0 3.645 3.644 3.65 3.65 0 0 0 3.645-3.644 3.65 3.65 0 0 0-3.645-3.645m0 5.649c-1.105 0-2.004-.9-2.004-2.004s.899-2.004 2.004-2.004 2.004.899 2.004 2.004a2.006 2.006 0 0 1-2.004 2.004M14 2.392A4.875 4.875 0 0 0 9.13 7.26 4.875 4.875 0 0 0 14 12.13a4.875 4.875 0 0 0 4.87-4.87A4.875 4.875 0 0 0 14 2.39m0 8.098a3.23 3.23 0 0 1-3.229-3.23A3.23 3.23 0 0 1 14 4.033a3.23 3.23 0 0 1 3.229 3.229 3.23 3.23 0 0 1-3.23 3.228M22.528 6.918a3.65 3.65 0 0 0-3.645 3.645 3.65 3.65 0 0 0 3.645 3.644 3.65 3.65 0 0 0 3.645-3.644 3.65 3.65 0 0 0-3.645-3.645m0 5.649c-1.105 0-2.004-.9-2.004-2.004s.899-2.004 2.004-2.004 2.004.899 2.004 2.004a2.006 2.006 0 0 1-2.004 2.004"
    ></path>
  </svg>
)

export default IconACSizes
